import { MenuItemProps } from '@chakra-ui/react';
import Button from '~/components/Button';
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownList,
} from '~/components/Dropdown';
import { ThreeDotsIcon } from '~/components/icons';

import { MenuItem } from './Actions.types';

interface Props extends MenuItemProps {
  dropDownMenuActions: MenuItem[];
}

export const ActionsDropDown: React.FC<Props> = ({
  dropDownMenuActions,
  ...props
}) => (
  <Dropdown>
    {() => {
      return [
        <DropdownButton
          data-testid="three-dots-button"
          as={Button}
          variant="ghost"
          colorScheme="primary"
          rounded="full"
          _active={{ backgroundColor: 'primary.100' }}
          key="button"
          padding={0}
          border="none"
          {...props}
        >
          <ThreeDotsIcon color="primary.500" width={8} height={8} />
        </DropdownButton>,
        <DropdownList key="list" border="unset">
          {dropDownMenuActions.map((menuItem) => (
            <DropdownItem
              key={menuItem.label}
              color="primary.500"
              onClick={menuItem.onClick}
              fontWeight="medium"
            >
              {menuItem.label}
            </DropdownItem>
          ))}
        </DropdownList>,
      ];
    }}
  </Dropdown>
);
